// View-model types for the dashboard. Hooks map raw API payloads into these;
// presentational widgets only ever see these shapes.

export type Period = "7d" | "30d" | "90d";

export const PERIOD_DAYS: Record<Period, number> = {
  "7d": 7,
  "30d": 30,
  "90d": 90,
};

export interface UsagePoint {
  date: string; // YYYY-MM-DD (local)
  requests: number;
  promptTokens: number;
  completionTokens: number;
}

export interface UsageTotals {
  requests: number;
  tokens: number;
}

export interface UsageSeries {
  points: UsagePoint[];
  current: UsageTotals;
  previous: UsageTotals;
  /** Admin daily stats only carry request counts. */
  hasTokens: boolean;
}

export interface UsageSummary {
  totalRequests: number;
  monthlyQuota: number;
  successRate: number;
  todayRequests: number;
  tokens: { input: number; output: number };
  providers: { name: string; percentage: number }[];
}

export interface ModelCost {
  model: string;
  provider: string;
  requests: number;
  totalTokens: number;
  totalCost: number;
}

export interface Consumption {
  totalCost: number;
  totalTokens: number;
  totalRequests: number;
  models: ModelCost[];
}

export interface SubscriptionInfo {
  planName: string;
  tier: string;
  tokensUsed: number;
  tokensLimit: number;
  requestsUsed: number;
  requestsLimit: number;
  periodEnd: string | null;
}

export interface CreditInfo {
  balance: number;
  currency: string;
}

export interface RecentRequest {
  id: string;
  provider: string;
  model: string;
  totalTokens: number;
  durationMs: number;
  successful: boolean;
  createdAt: string;
  username?: string;
}
